import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { ITRequestFormResponse } from '@Types/api/form';
import { RequestListSearchResponse } from '@Types/api/requestList';
import { parseDateTime } from '@Utils/transformDateTime';

import { TypeDict } from 'types';
import { ColumnDataType } from './type';

export const dataSourceMap = (
  data: RequestListSearchResponse<ITRequestFormResponse>,
  findRequistionType: (statusNum: number) => TypeDict | undefined,
  findRequistionStatus: (statusNum: number) => TypeDict | undefined
): Array<ColumnDataType> => {
  if (!data?.content) return [];

  return data?.content?.map((requestItem) => {
    const reqTypeDesc = findRequistionType(requestItem.reqItemId)?.codeDesc;
    const statusDesc = findRequistionStatus(requestItem.statusId)?.codeDesc;
    const dateOfJoining = parseDateTime(requestItem?.dateOfJoining);
    const empName = requestItem?.empName;
    const occupation = requestItem?.occupation;

    return {
      key: requestItem.requestId,
      requestNo: requestItem.requestId,
      reqItemId: reqTypeDesc || '',
      deptProject: 'IT',
      empNo: requestItem.empNumber,
      empName: empName || '',
      approverName: requestItem.approverName,
      occupation: occupation || EMPTY_FIELD_PLACEHOLDER,
      dateOfJoining: dateOfJoining || EMPTY_FIELD_PLACEHOLDER,
      status: statusDesc || '',
      actions: '',
    };
  });
};
